export default __webpack_public_path__ + "static/media/notification.b7a1bbfc.svg";